// src/components/dashboard/widgets/tasks-panel.tsx
import { CheckSquare, Clock, CheckCircle, XCircle } from 'lucide-react';

interface TaskItem {
  id: string;
  title: string;
  priority?: string | null;
  assigned_to?: string | null;
  acceptance_status?: string | null;
}
interface MemberItem { id: string; name: string }

const PRIORITY_STYLES: Record<string, string> = {
  urgent: 'text-red-400 bg-red-500/10 border-red-500/20',
  high: 'text-amber-400 bg-amber-500/10 border-amber-500/20',
  normal: 'text-cream-muted border-cream-line',
  low: 'text-cream-muted/50 border-cream-line',
};

interface TasksPanelProps {
  openCount: number;
  urgentTasks: TaskItem[];
  members: MemberItem[];
}

export default function TasksPanel({ openCount, urgentTasks, members }: TasksPanelProps) {
  return (
    <div className="rounded-2xl border border-cream-line bg-warm-gray p-5 space-y-3 h-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-semibold text-cream">
          <CheckSquare size={14} className="text-leaf-400" /> Tasks
        </div>
        <span className="text-xs text-cream-muted">{openCount} open</span>
      </div>
      {urgentTasks.length === 0 ? (
        <p className="text-xs text-cream-muted/50 py-4 text-center">No urgent tasks</p>
      ) : (
        <div className="space-y-2">
          {urgentTasks.map((t) => (
            <div key={t.id} className="flex items-center gap-2 py-1.5 border-b border-cream-line/30 last:border-0">
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-cream truncate">{t.title}</p>
                <p className="text-[11px] text-cream-muted">
                  {t.assigned_to ? members.find((m) => m.id === t.assigned_to)?.name ?? 'Assigned' : 'Unassigned'}
                </p>
              </div>
              <div className="flex items-center gap-1">
                {t.acceptance_status === 'accepted' ? (
                  <CheckCircle size={12} className="text-leaf-400" />
                ) : t.acceptance_status === 'declined' ? (
                  <XCircle size={12} className="text-red-400" />
                ) : (
                  <Clock size={12} className="text-amber-400" />
                )}
                <span className={`text-[9px] font-bold uppercase px-1.5 py-0.5 rounded-full border ${PRIORITY_STYLES[t.priority ?? 'normal']}`}>
                  {t.priority}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}